// import typography from "@tailwindcss/typography"
// import plugin from "tailwindcss/plugin"
// import containerQueries from "@tailwindcss/container-queries"
import defaultTheme from "tailwindcss/defaultTheme"

/** @type {import('tailwindcss').Config} */
export default {
  content: ["./src/**/*.{astro,html,js,jsx,md,mdx,svelte,ts,tsx,vue}"],
  theme: {
    extend: {
      backgroundColor: ({ theme }) => ({
        brand: theme("colors.pacific-blue.DEFAULT"),
      }),
      borderColor: ({ theme }) => ({
        brand: theme("colors.pacific-blue.DEFAULT"),
      }),
      colors: {
        "arctic-blue": {
          1: "#f5fafd",
          2: "#e1effa",
          DEFAULT: "#0b395b",
          4: "#022946",
        },
        "atlantic-blue": {
          1: "#f5fcff",
          2: "#e2f5fd",
          DEFAULT: "#25b5f3",
          3: "#9edefa",
          4: "#6ecef7",
          6: "#007ab4",
        },
        "baltic-blue": "#031d30",
        "pacific-blue": {
          1: "#b1d8fe",
          2: "#3c9dfd",
          DEFAULT: "#0274e8",
          4: "#013a74",
          5: "#012a53",
        },
        "horizon-yellow": {
          1: "#fefcf6",
          2: "#ffefb4",
          DEFAULT: "#ffd53e",
          3: "#ffea9d",
          4: "#ffdc60",
          6: "#fdc600",
        },
        "palm-green": {
          1: "#e8faf6",
          2: "#d5f6ee",
          DEFAULT: "#1cc0a5",
          3: "#60e9c9",
          5: "#077577",
          6: "#055461",
        },
        "sunset-orange": {
          1: "#fef9ef",
          2: "#ffcc9f",
          DEFAULT: "#e86143",
          3: "#ffa979",
          4: "#ff8255",
          6: "#bd432b",
        },
        "thistle-purple": {
          1: "#f4effd",
          2: "#d2c1f6",
          DEFAULT: "#8453e6",
          3: "#a682ed",
          5: "#6325e0",
          6: "#3f1592",
        },
        grey: {
          1: "#f7fafc",
          2: "#edf2f7",
          3: "#e2e8f0",
          4: "#cbd2dd",
          5: "#75808f",
          6: "#5c6677",
          7: "#2d3748",
          8: "#1a202c",
        },
        current: "currentColor",
        error: "#bd432b",
      },
      fontFamily: {
        primary: ["Averta PE", "sans"],
        secondary: ["Playfair Display", "serif"],
        sans: ["Averta PE", ...defaultTheme.fontFamily.sans],
      },
      fontSize: {
        inherit: "inherit",
        xs: [
          "12px",
          {
            lineHeight: "20px",
          },
        ],
        sm: [
          "14px",
          {
            lineHeight: "24px",
          },
        ],
        lg: [
          "18px",
          {
            lineHeight: "36px",
          },
        ],
        xl: [
          "20px",
          {
            lineHeight: "36px",
          },
        ],
        "2xl": [
          "22px",
          {
            lineHeight: "40px",
          },
        ],
        "3xl": [
          "24px",
          {
            lineHeight: "44px",
          },
        ],
        "4xl": [
          "28px",
          {
            lineHeight: "48px",
          },
        ],
        "5xl": [
          "36px",
          {
            lineHeight: "48px",
          },
        ],
        "6xl": [
          "44px",
          {
            lineHeight: "64px",
          },
        ],
      },
      fontWeight: ({ theme }) => ({
        "bold-heading": 600,
        "bold-subheading": 400,
      }),
      lineHeight: {
        "leading-2": "20px",
        "leading-3": "24px",
        "leading-4": "36px",
        "leading-5": "40px",
        "leading-6": "44px",
        "leading-7": "48px",
        "leading-8": "64px",
      },
      margin: {
        xs: "6px",
        sm: "10px",
        md: "24px",
        lg: "48px",
        xl: "64px",
        "2xl": "96px",
        "3xl": "144px",
      },
      stroke: ({ theme }) => ({
        brand: theme("colors.pacific-blue.DEFAULT"),
      }),
      textColor: ({ theme }) => ({
        brand: theme("colors.pacific-blue.DEFAULT"),
      }),
      gap: {
        "content-container": "60px",
        "group-container": "80px",
        "heading-container": "22px",
        "text-container": "40px",
        xs: "8px",
        sm: "16px",
        md: "24px",
        lg: "48px",
        xl: "64px",
        "2xl": "96px",
        "3xl": "144px",
      },
      padding: {
        "block-mobile": "96px",
        "block-tablet": "96px",
        "block-desktop": "96px",
        "inline-mobile": "24px",
        "inline-tablet": "48px",
        "inline-desktop": "48px",
        xs: "6px",
        sm: "10px",
        md: "24px",
        lg: "48px",
        xl: "64px",
        "2xl": "96px",
        "3xl": "144px",
      },
      screens: {
        mobile: { min: "375px", max: "767px" },
        tablet: { min: "768px", max: "1279px" },
        desktop: { min: "1280px" },
        mobile1: { min: "375px", max: "424px" },
        mobile2: { min: "425px", max: "599px" },
        tablet1: { min: "600px", max: "767px" },
        tablet2: { min: "768px", max: "949px" },
        desktop1: { min: "950px", max: "1023px" },
        desktop2: { min: "1024px", max: "1279px" },
        desktop3: { min: "1280px", max: "1439px" },
        desktop4: { min: "1440px" },
        "desktop-lg": { min: "1440px" },
        "min-mobile": { min: "375px" },
        "min-mobile1": { min: "375px" },
        "min-mobile2": { min: "425px" },
        "min-tablet1": { min: "600px" },
        "min-tablet2": { min: "768px" },
        "min-desktop1": { min: "950px" },
        "min-desktop2": { min: "1024px" },
        "min-desktop3": { min: "1280px" },
        "min-desktop4": { min: "1440px" },
        "min-tablet": { min: "768px" },
        "min-nav-desktop": { min: "1155px" },
      },
      space: {
        xs: "6px",
        sm: "10px",
        md: "24px",
        lg: "48px",
        xl: "64px",
        "2xl": "96px",
        "3xl": "144px",
      },
      typography: {
        DEFAULT: {
          css: {
            "max-width": "100%",
          },
        },
      },
    },
  },
  plugins: [
    require("@tailwindcss/container-queries"),
    require("@tailwindcss/typography"),
  ],
}
